<template>
<div class="dance-project-manage">
    <device-list v-if="deviceListVisible" @close="close" @confirm="onTargetDeviceConfirm"></device-list>
    <project-list v-if="projectListVisible" @close="close" :device="targetDevice"></project-list>
</div>
    
</template>
<script>
import { mapState } from 'vuex';
import projectList from './dance-projects-list'
import deviceList from './device-list'
export default {
    name: 'dance-project',
    components: {
        projectList,
        deviceList
    },
    props: {
        visible: Boolean
    },
    data(){
        return {
            targetDevice: null,
            projectListVisible: false,
            deviceListVisible: false
        }
    },
    computed: {
        ...mapState('quickConnection', {
            quickDevices: 'connectDevices'
        }),
        ...mapState('whiteConnection', {
            'whiteDevices': 'rmsGroups'
        }),
        ...mapState('rmsConnection', {
            rmsDevices: 'rmsGroups'
        }),
        ...mapState([
            'connectGolbalState',
            'userInfo',
            'currentVersion'
        ]),
        hasConnection(){
            return [1, 2, 3].includes(this.connectGolbalState)
        },
        devices(){
            if(!this.hasConnection || !['teacher', 'student'].includes(this.currentVersion)){
                return []
            }
            const connectState = this.connectGolbalState
            if(connectState === 1){
                return this.rmsDevices
            } if(connectState === 3){
                return this.whiteDevices
            } else {
                return []
            }
        }
    },
    watch: {
        visible(value){
            if(value){
                this.start()
            }
        }
    },
    created(){
        this.start()
    },
    methods: {
        start(){
            console.log("connectGolbalState", this.connectGolbalState)
            this.targetDevice = null
            if(!this.hasConnection){
                this.showConnectTips()
                return
            }
            if(['teacer', 'student'].includes(this.currentVersion)){
                this.deviceListVisible = true
            } else if(this.quickDevices.length > 0) {
                this.targetDevice = this.quickDevices[0]
                this.projectListVisible = true
            }
        },
        showConnectTips() {
            let h = this.$createElement;
            let message = h("div", {
                style: {
                    textAlign: "center"
                }
            }, [
                h("svg-icon", {
                    props: {
                        href: "#codelab-connect-warn",
                        width: 150,
                        height: 150
                    }
                }),
                h("div", {
                    style: {
                        fontSize: "14px",
                        color: "#ffffff",
                        lineHeight: 1.5,
                        paddingTop: "16px"
                    },
                    domProps: {
                        innerHTML: this.$t("message.warn_before_add_dance_projects")
                    }
                })
            ]);
            this.$confirm(message, this.$t("popper_title.has_no_connected_robot"), {
                dangerouslyUseHTMLString: true,
                center: true,
                showClose: false,
                confirmButtonText: this.$t("code-lab/component/connection/ip/ip-connection.vue_11"),
                cancelButtonText: this.$t("code-lab/component/robot-connect/play-button/play-on-robot.vue_23"),
                customClass: "codelab-important-tip",
                cancelButtonClass: "codelab-button gray",
                confirmButtonClass: "codelab-button blue"
            }).then(() => {
                this.showConnectPopper()
            }).catch(() => {
                this.close()
            });
        },
        showConnectPopper(){
            if(this.userInfo && this.userInfo.currentTeam){
                const {
                    isRmsScope,
                    isBiz
                } = this.userInfo.currentTeam
                console.log('current team:', this.userInfo.currentTeam)
                if(this.currentVersion === 'teacher'){
                    if(isRmsScope){
                        console.log("打开rms连线")
                    } else if(isBiz){
                        console.log('打开白名单连线')
                    }
                } else if(this.currentVersion === 'student'){
                    console.log('打开白名单连线')
                } else {
                    this.$store.commit('quickConnection/switchQuickHandler', true);
                }
                this.close()
            }
        },
        onTargetDeviceConfirm(device){
            this.targetDevice = device
            this.deviceListVisible = false
            this.$nextTick(() => {
                this.projectListVisible = true
            })
        },
        close() {
            this.projectListVisible = false
            this.deviceListVisible = false
            this.$emit('update:visible', false)
        }
    }
}
</script>
<style lang="scss">
.codelab-popper.codelab-robot-dance-projects{
    .el-dialog__body{
        padding: 24px 10px 0 10px;
    }
    .el-dialog__footer{
        padding: 20px;
        box-shadow: 0 -35px 30px 5px rgba(51, 51, 51, 0.8);
    }
}
</style>